import React, { useMemo } from "react";
import { Box, Typography, Icon } from "@mui/material";
import { AppTable } from "../../../../../components/AppTable";
import { LedgerTableProps } from "../types";
import { createLedgerColumns } from "../ledgerColumns";

export const LedgerTable: React.FC<LedgerTableProps> = ({
  data,
  pagination,
  onJournalEntryClick,
  onCopyJournalId,
}) => {
  const columns = useMemo(
    () => createLedgerColumns({ onJournalEntryClick, onCopyJournalId }),
    [onJournalEntryClick, onCopyJournalId]
  );

  if (data.length === 0) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          gap: 2,
        }}
      >
        <Icon sx={{ fontSize: 64, color: "text.secondary" }}>
          account_balance
        </Icon>
        <Typography variant="h6" sx={{ color: "text.secondary" }}>
          Select an account to view ledger
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          Choose an account from the dropdown above
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <AppTable
        columns={columns}
        data={data}
        pagination={pagination}
        styleOptions={{
          bordered: true,
          columnSeparators: true,
        }}
        variant="default"
        loading={false}
        onRowClick={(row) => {
          if (!row.isOpeningBalance && row.originalEntry) {
            onJournalEntryClick(row.originalEntry);
          }
        }}
        emptyState={{
          icon: "account_balance",
          title: "No Transactions Found",
          description: "No transactions found for the selected filters",
        }}
      />
    </Box>
  );
};
